import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { c, h } from '@debbie/cortex/dist/index.js';
import { useCustomerRelatedCases } from '@debbie/cortex/dist/customers-related-cases/index.js';
import CaseStatus from '../CaseStatus.js';
import { ExternalLink } from '../Icons/index.js';
import PlaceholderLoader from '../PlaceholderLoader.js';
import Table from '../Table.js';
const CasesRelatedToCustomer = (props) => {
    const lang = useSelector((s) => s.lang);
    const relatedCasesLoadable = useCustomerRelatedCases(props.customerId);
    const relatedCases = h.hasData(relatedCasesLoadable)
        ? relatedCasesLoadable.data
        : null;
    return (React.createElement("div", { style: {
            fontSize: '0.8em',
            cursor: 'default',
        }, onClick: (e) => {
            e.stopPropagation();
        } }, relatedCases ? (relatedCases.length ? (React.createElement(Table, { zebra: true },
        React.createElement("tr", null,
            React.createElement("th", null, lang.customers.caseStatus),
            React.createElement("th", null, lang.customers.relationType),
            React.createElement("th", null, lang.customers.creditor),
            React.createElement("th", { style: { width: '85px', textAlign: 'right', cursor: 'pointer' }, onClick: () => c.redirect.redirect(`/cases/${relatedCases
                    .map((_case) => _case.caseSeqId)
                    .join(',')}`) },
                lang.customers.case,
                " ",
                React.createElement(ExternalLink, null))),
        relatedCases
            .sort((a, b) => a.caseSeqId - b.caseSeqId)
            .map((relatedCase) => (React.createElement(Relation, { key: relatedCase.caseId },
            React.createElement("td", null,
                React.createElement(CaseStatus, { status: relatedCase.caseStatus, endReasonId: relatedCase.caseEndReasonId, statusTime: relatedCase.caseStatusTime })),
            React.createElement("td", null, relatedCase.relation
                .map((relation) => lang.customerCaseRelationType[relation] || relation)
                .join(', ')),
            React.createElement("td", null, relatedCase.creditorName),
            React.createElement("td", { style: { textAlign: 'right', cursor: 'pointer' }, onClick: () => c.redirect.redirect(`/cases/${relatedCase.caseSeqId}`) },
                relatedCase.caseSeqId,
                " ",
                React.createElement(ExternalLink, null))))))) : (React.createElement("h3", null, lang.customers.noRelatedCases))) : (React.createElement(PlaceholderLoader, null))));
};
export default CasesRelatedToCustomer;
const Relation = styled.tr ``;
//# sourceMappingURL=CasesRelatedToCustomer.js.map